const styles = (theme) => ({
  // Styles for the Stack component
  width: "100%",

  // Custom styles for the bigCalendar component
  ...theme.bigCalendarCustomStyle,

  "& .rbc-calendar": {
    width: "100%",
  },

  "& .rbc-time-header": {
    boxShadow: "2px 1px 3px 0px rgba(0, 0, 0, 0.12)",
  },

  "& .rbc-header + .rbc-header": {
    borderLeft: "none",
  },

  "& .rbc-day-slot .no-selectable": {
    pointerEvents: "none",
  },
});

export default styles;
